import { Colors, CommonInput, FlexBox, INPUT_TYPES } from "@brg/ui";
import { FC } from "react";
import { WrappedFieldProps } from "redux-form";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { PatternFormat } from "react-number-format";
import { useTranslation } from "react-i18next";

export const InputContainer = styled(FlexBox)`
  width: 610px;
  position: relative;

      input {
          &:disabled {
              color: #909090 !important;
          }
      }
  
      input, textarea {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47} !important;
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
          &:focus {
            border-color: transparent !important;
            box-shadow: none !important;
            outline: none !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47} !important;
          }
      }
  
      input {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
  
              input {
                  height: 48px !important;
              }
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input {
              height: 48px !important;
          }
      }
`;

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  countryCode?: string;
  placeholder?: string;
  defaultValue?: string;
  style?: React.CSSProperties;
}

const PhoneInput: FC<BilingualTextInputProps> = ({
  input, 
  meta,
  label,
  required,
  multiline,
  maxLength,
  placeholder,
  defaultValue,
  style,
  countryCode = '',
  ...props
}) => {
  const { i18n: { language }} = useTranslation();
  const getFormatPattern = () => {
    if (countryCode === 'ru' || countryCode === 'RU') {
      return "+7 (###) ###-##-##";
    }
    return "+# (###) ###-####";
  };

  return (
    <GridRow>
      <CommonInput 
        type={INPUT_TYPES.phone}
        {...props}
        onChange={(values: any) => {
          input.onChange(values);
        }}
        globalLang={language}
        value={input?.value}
        label={label}
        required={required}
        placeholder={''}
      />
      {/* <FormLabel isTeamEdit>
        {label}
        {required && <LabelRedStar>*</LabelRedStar>}
      </FormLabel>
      <InputContainer direction="column" directionMobile="column">
        <PatternFormat
          {...input}
          {...props}
          format={getFormatPattern()}
          mask="_"
          allowEmptyFormatting
          onValueChange={(values) => {
            input.onChange(values.formattedValue);
          }}
          style={{ paddingLeft: '16px' }}
          placeholder={placeholder || "+1 (234) 567-8900"}
        />
      </InputContainer> */}
    </GridRow>
  );
}

export default PhoneInput;import { Colors, CommonInput, FlexBox, INPUT_TYPES } from "@brg/ui";
import { FC } from "react";
import { WrappedFieldProps } from "redux-form";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { PatternFormat } from "react-number-format";
import { useTranslation } from "react-i18next";

export const InputContainer = styled(FlexBox)`
  width: 610px;
  position: relative;

      input {
          &:disabled {
              color: #909090 !important;
          }
      }
  
      input, textarea {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47} !important;
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
          &:focus {
            border-color: transparent !important;
            box-shadow: none !important;
            outline: none !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47} !important;
          }
      }
  
      input {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
  
              input {
                  height: 48px !important;
              }
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input {
              height: 48px !important;
          }
      }
`;

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  countryCode?: string;
  placeholder?: string;
  defaultValue?: string;
  style?: React.CSSProperties;
}

const PhoneInput: FC<BilingualTextInputProps> = ({
  input, 
  meta,
  label,
  required,
  multiline,
  maxLength,
  placeholder,
  defaultValue,
  style,
  countryCode = '',
  ...props
}) => {
  const { i18n: { language }} = useTranslation();
  const getFormatPattern = () => {
    if (countryCode === 'ru' || countryCode === 'RU') {
      return "+7 (###) ###-##-##";
    }
    return "+# (###) ###-####";
  };

  return (
    <GridRow>
      <CommonInput 
        type={INPUT_TYPES.phone}
        {...props}
        onChange={(values: any) => {
          input.onChange(values);
        }}
        globalLang={language}
        value={input?.value}
        label={label}
        required={required}
        placeholder={''}
      />
      {/* <FormLabel isTeamEdit>
        {label}
        {required && <LabelRedStar>*</LabelRedStar>}
      </FormLabel>
      <InputContainer direction="column" directionMobile="column">
        <PatternFormat
          {...input}
          {...props}
          format={getFormatPattern()}
          mask="_"
          allowEmptyFormatting
          onValueChange={(values) => {
            input.onChange(values.formattedValue);
          }}
          style={{ paddingLeft: '16px' }}
          placeholder={placeholder || "+1 (234) 567-8900"}
        />
      </InputContainer> */}
    </GridRow>
  );
}

export default PhoneInput;